import { useEffect, useState } from 'react';
import { useLang } from '../context/LanguageContext';
import { getAnalyticsConsent, setAnalyticsConsent } from '../utils/analytics';
import './CookieConsent.css';

export default function CookieConsent() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getAnalyticsConsent()) return;
    const tmr = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(tmr);
  }, []);

  const accept = () => {
    setAnalyticsConsent('accepted');
    setVisible(false);
  };

  const reject = () => {
    setAnalyticsConsent('rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite" aria-label={t.cookieConsentTitle} data-sub-free>
      <div className="cookie-consent__inner">
        <p className="cookie-consent__text">{t.cookieConsentText}</p>
        <div className="cookie-consent__actions">
          <a href="/privacy" className="cookie-consent__link">
            {t.footerPrivacy}
          </a>
          <button type="button" className="cookie-consent__btn cookie-consent__btn--ghost" onClick={reject}>
            {t.cookieConsentReject}
          </button>
          <button type="button" className="cookie-consent__btn" onClick={accept}>
            {t.cookieConsentAccept}
          </button>
        </div>
      </div>
    </div>
  );
}
